import { Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Tooltip from '@mui/material/Tooltip';

const StyledTooltip = withStyles({
  tooltip: {
    background: '#1D2939',
    border: '1px solid #101828',
    padding: '12px 22px',
  },
  arrow: {
    '&::before': {
      border: '1px solid rgba(0, 0, 0, 0.24)',
      background: '#1D2939',
      boxSizing: 'border-box',
    },
  },
})(Tooltip);

const CustomHover = styled(Typography)`
  &.MuiTypography-root {
    font-size: 13px;
    line-height: 16px;
    color: #ffffff;
    display: block;
    text-align: left;
  }
`;

const UserTableTooltip = (props) => {
  const { data } = props;
  const toolTipTitle = (userProjects = []) => {
    const projectNames = userProjects.map((r) => r?.project?.name);
    const tooltipProjectName = projectNames.map((val, index) => <span key={`${val}${index}`}>{val}<br /></span>);
    return <CustomHover>{tooltipProjectName}</CustomHover>;
  };

  const projectNames = (userProjects = []) => {
    const totalProjects = userProjects.length;
    switch (totalProjects) {
      case 1:
        return userProjects[0]?.project?.name;
      default:
        return (
          <span className="text-underline blue-text cursor-pointer">
            {totalProjects}
            <span> Projects</span>
          </span>
        );
    }
  };
  return (
    data?.projects?.length
      ? (
        <StyledTooltip placement="bottom" arrow disableHoverListener={false} title={toolTipTitle(data.projects)}>
          <span>{projectNames(data.projects)}</span>
        </StyledTooltip>)
      : '-'
  );
};

UserTableTooltip.propTypes = {
  data: PropTypes.shape({
    projects: PropTypes.array,
  }),
};

export default UserTableTooltip;
